import React from 'react';
import {withTranslation} from "react-i18next";
import ToOverviewComponent from "./ToOverviewComponent";

let rewardNotFound = ({t}) => {
    return <div className="reward-not-found">
        {t('reward.notfound')}
        <ToOverviewComponent/>
    </div>
};

export default withTranslation() (rewardNotFound)